import { TFunction } from 'i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

export const getDocumentDraftCreationNotification = (documentType: InvoiceDocumentType, t: TFunction) => {
  switch (documentType) {
    case InvoiceDocumentType.Quote:
      return t('external_invoices.quote_saved_as_draft')
    case InvoiceDocumentType.Invoice:
    default:
      return t('external_invoices.invoice_saved_as_draft')
  }
}
